<template>
  <v-container>
    <v-row align="center" justify="center">

      <v-col cols="12" sm="8" md="6" class="text-center">
        <v-card>

          <v-card-title>
            Bloquear rotación de Agencia

            <v-btn text absolute right link small href="/files/BloquearAgencia.csv" target="_blank">
              <v-icon left>download</v-icon>
              CSV de ejemplo
            </v-btn>
          </v-card-title>


          <v-card-text>
            <file-upload-express
                @fileUploaded="onFileUploaded"
                auto-submit
            ></file-upload-express>
            <template v-if="!file">
              <h4  class="subtitle-1">Subir archivo .csv</h4>

              <div class="text-left">

                <h3 class="text-left primary--text">Campos del csv</h3><br>


                <ul class="text-left">
                  <li><b>dni</b> <span class="red--text">*</span></li>
                  <li><b>rotacionBloqueada</b> <span class="red--text">*</span> Valores:  true | false </li>
                </ul>
              </div>
            </template>
          </v-card-text>

          <v-card-text v-if="file && !jobId">
            <v-alert type="info">
              Archivo subido exitosamente. Generando tarea de importación en segundo plano.
            </v-alert>
            <v-progress-circular indeterminate></v-progress-circular>
          </v-card-text>

          <v-card-text v-if="jobId">
            <v-alert type="success">
              Tarea de importación en segundo plano generada con éxito.<br> Id: {{ jobId }}
            </v-alert>
          </v-card-text>

          <v-card-actions v-if="jobId">
            <v-spacer></v-spacer>
            <v-btn
                :to="{name:'JobPage',params:{id: jobId}}"
                color="indigo" dark
            >
              Supervisar tarea
            </v-btn>
          </v-card-actions>


        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import JobProvider from "@/modules/cobrox/providers/JobProvider";
import {FileUploadExpress} from "@dracul/media-frontend";

export default {
  name: "BloquearAgenciaPage",
  components: {FileUploadExpress},
  data() {
    return {
      file: null,
      jobId: null,
    }
  },
  methods: {
    onFileUploaded(file) {
      this.file = file
      this.createJob(this.file.id)
    },
    createJob(fileId) {
      JobProvider.bloquearAgenciaPersona(fileId)
          .then(res => {
            this.jobId = res.data.bloquearAgenciaPersona
          })
    }
  }
}
</script>

<style scoped>

</style>
